export const RoyaltyReportWrapper = (data) =>
{
  const result = [];
  data.forEach(main => {
    let mainRow = {
      uuid: main.id,
      is_main: true,
      name: main.name,
      owner: main.owner,
      territory: "All",
      total_sales: main.territory_sales.owned.total_sales + main.territory_sales.unowned.total_sales,
      territory_sales: 0,
      franchise: {uuid: main.id, name: main.name}
    }
    result.push(mainRow);

    main.territory_sales.owned.territory_data.forEach(item => {
      let row = {
        uuid: item.territory_id,
        is_main: false,
        is_owned: true,
        name: main.name,
        owner: main.owner,
        territory: item.territory.charAt(0).toUpperCase() + item.territory.slice(1),
        total_sales: 0,
        territory_sales: item.total_sales,
        franchise: {uuid: main.id, name: main.name}
      }

      result.push(row);
    });

    main.territory_sales.unowned.territory_data.forEach(item => {
      let row = {
        uuid: item.territory_id,
        is_main: false,
        is_owned: false,
        name: main.name,
        owner: main.owner,
        territory: item.territory,
        total_sales: 0,
        territory_sales: item.total_sales,
        franchise: {uuid: main.id, name: main.name}
      }

      result.push(row);
    });
  });

  return {...data, result};
}